import { PLACE_CATEGORIES, categoryById, toggleCategory, type PlaceCategoryId } from "../../../shared/categories";

type Props = {
  selected: PlaceCategoryId[];
  onChange: (next: PlaceCategoryId[]) => void;
  title?: string;
  compact?: boolean;
};

/** Selector de categorías de actividad: se pueden activar y desactivar varias a la vez. Ninguna marcada = todas. */
export function CategoryFilter({ selected, onChange, title = "Qué te apetece", compact = false }: Props) {
  return (
    <div className="category-filter">
      <p className="label">{title}</p>
      {compact ? null : (
        <p className="muted category-help">
          Activa las categorías que quieras (puedes marcar varias). Si no marcas ninguna, se busca de todo.
        </p>
      )}
      <div className="category-grid" role="group" aria-label={title}>
        {PLACE_CATEGORIES.map((cat) => {
          const on = selected.includes(cat.id);
          return (
            <button
              key={cat.id}
              type="button"
              role="checkbox"
              aria-checked={on}
              className={`social-chip category-chip${on ? " on" : ""}`}
              onClick={() => onChange(toggleCategory(selected, cat.id))}
            >
              <span aria-hidden>{cat.icon}</span>
              {cat.label}
              {compact ? null : <small>{cat.hint}</small>}
            </button>
          );
        })}
      </div>
      {selected.length ? (
        <p className="muted category-help">
          {selected.map((id) => categoryById(id).label).join(" + ")} ·{" "}
          <button type="button" className="link-btn" onClick={() => onChange([])}>
            Quitar filtros
          </button>
        </p>
      ) : null}
    </div>
  );
}
